import React from 'react';
import './LoadingPayment.css'
import ColouredLoadingSymbol from '../../../../../../../../../STCLibrary/LoadingAnimation/ColouredLoadingSymbol/ColouredLoadingSymbol';

export default function LoadingPayment(){

    return(
        <div className='loading-payment-container'>
            {/* <div className='info-card'>
                <h3>Redirecting</h3> */}
                {/* <div className='loading-symbol'>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div> */}

            <ColouredLoadingSymbol message={'Redirecting'}/>
            {/* </div> */}
        </div>
    )

}